export class RespBoardingPass {
  pectabList: string;
  passengers: { passengerNameNumber: string; travelDocuments: string[] }[];

  constructor(resp: any) {
    this.pectabList = resp?.pectabList?.[0]?.pectab || '';
    this.passengers = [];

    if (resp && resp.passengers) {
      for (const pax of resp.passengers) {
        const travelDocs: string[] = [];

        for (const seg of pax.checkinStatusBySegment || []) {
          if (seg.boardingPass?.travelDoc) {
            travelDocs.push(seg.boardingPass.travelDoc);
          }
        }

        this.passengers.push({
          passengerNameNumber: pax.passengerNameNumber,
          travelDocuments: travelDocs,
        });
      }
    }
  }
}
